import { action } from 'typesafe-actions';
import { fundingTrackingDataActionTypes as act } from './fundingTrackingDataActionTypes';

export function storeFundingTrackingData(type) {
  return action(act.STORE, type);
}
